import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";
import Kraje from "../Kraje";
import Lata from "../Lata";
import Warstwy from "../Warstwy";
import Tryby from "../Tryby";

class Filtry extends PureComponent {
  static contextType = AppContext;

  render() {
    const { modes } = this.context;
    const mode = modes.filter((mode: any) => mode.isSelected)[0].id;
    return (
      <div className="Filtry">
        <Tryby />
        {mode === "past" && <Warstwy />}
        {mode === "past" && <Lata />}
        {mode === "past" && <Kraje />}
      </div>
    );
  }
}

export default Filtry;
